import { useContext } from 'react';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { SwitchThemeContext } from '@tryhackme/thm-ui-components';
import { ThemeColorMode } from 'src/common/enums';
import { StyledExclamationIcon, StyledWarningBox, StyledWarningText } from './warning-box.styles';
export const WarningBox = ({
  warningText
}: {
  warningText: string;
}) => {
  const {
    theme
  } = useContext(SwitchThemeContext);
  const isDarkMode = theme === ThemeColorMode.DARK;
  return <StyledWarningBox isDarkMode={isDarkMode} data-sentry-element="StyledWarningBox" data-sentry-component="WarningBox" data-sentry-source-file="warning-box.tsx">
      <StyledExclamationIcon icon={faExclamationCircle} data-sentry-element="StyledExclamationIcon" data-sentry-source-file="warning-box.tsx" />
      <StyledWarningText data-sentry-element="StyledWarningText" data-sentry-source-file="warning-box.tsx">{warningText}</StyledWarningText>
    </StyledWarningBox>;
};